import { useBootstrap } from '../context/BootstrapContext'

export function useFAQs() {
  const { data, loading } = useBootstrap()
  return { faqs: data.faqs, loading }
}
